import React, { memo } from 'react';
import { View } from 'react-native';
import { createUseStyle } from '@redlink/assets/styles';
import { Space, IconArrowRight } from '@redlink/components/atoms';

export const ThemeItemThumbnale = memo(
  ({
    palette: {
      primary,
      saparator,
      title,
      subtitle,
      background,
      cardBackground,
    },
  }) => {
    const { styles } = useStyle();
    return (
      <View style={[styles.container, { backgroundColor: background }]}>
        <View style={styles.userinfoContainer}>
          <View
            style={[
              styles.userAvatarContainer,
              { backgroundColor: cardBackground },
            ]}
          />
          <Space size={8} />
          <View>
            <View
              style={[styles.userTitleContainer, { backgroundColor: title }]}
            />
            <Space size={8} />
            <View
              style={[
                styles.userSubtitleContainer,
                { backgroundColor: subtitle },
              ]}
            />
          </View>
        </View>
        <Space />
        <View
          style={[styles.linkContainer, { backgroundColor: cardBackground }]}
        >
          <View style={styles.linkBodyContainer}>
            <View
              style={[
                styles.linkThumbnaleContaner,
                { backgroundColor: primary },
              ]}
            />
            <Space size={8} />
            <View
              style={[styles.linkTitleContainer, { backgroundColor: title }]}
            />
          </View>
          <IconArrowRight size={16} color={title} />
        </View>
        <Space size={8} />
        <View
          style={[styles.cardContainer, { backgroundColor: cardBackground }]}
        >
          <View
            style={[styles.cardImageContainer, { backgroundColor: subtitle }]}
          />
          <Space />
          <View style={styles.cardBodyContainer}>
            <View
              style={[styles.cardTitleContainer, { backgroundColor: title }]}
            />
          </View>
        </View>
      </View>
    );
  }
);

const useStyle = createUseStyle(({ colors, shadow, size }) => ({
  container: {
    flex: 1,
    paddingHorizontal: 16,
    paddingTop: 16,
    paddingBottom: 8,
    justifyContent: 'center',
  },
  userinfoContainer: {
    flexDirection: 'row',
    alignItems: 'flex-end',
  },
  userAvatarContainer: {
    width: 40,
    height: 40,
    borderRadius: 20,
  },
  userTitleContainer: {
    width: 40,
    height: 8,
    borderRadius: 8,
  },
  userSubtitleContainer: {
    width: 80,
    height: 8,
    borderRadius: 4,
  },
  linkContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: 16,
    paddingVertical: 8,
    borderRadius: 12,
  },
  linkThumbnaleContaner: {
    width: 16,
    height: 8,
    borderRadius: 4,
  },
  linkTitleContainer: {
    width: 80,
    height: 8,
    borderRadius: 4,
  },
  linkBodyContainer: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
  },
  cardContainer: {
    paddingHorizontal: 8,
    paddingTop: 8,
    paddingBottom: 16,
    borderRadius: 12,
  },
  cardImageContainer: {
    height: 80,
    borderRadius: 8,
  },
  cardBodyContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingHorizontal: 8,
  },
  cardTitleContainer: {
    width: 80,
    height: 8,
    borderRadius: 4,
  },
  cardSubtitleContainer: {
    width: 24,
    height: 8,
    borderRadius: 4,
  },
}));
